// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import "../static/icon/iconfont/iconfont.css"
import "../static/icon/font-awesome-4.7.0/css/font-awesome.min.css"
import commonJS from "./assets/js/Common.js";

Vue.use(commonJS);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

Vue.use(ElementUI);

Vue.prototype.baseUrl = process.env.API_ROOT

Vue.config.productionTip = false
axios.defaults.withCredentials = true;
/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
});

// 百度统计
if (window.location.href.indexOf("jylt.cc") !== -1) {
  var _hmt = _hmt || [];
  window._html = _hmt;
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?9d583091dbd934ae5f7ef60efcd77892";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}

axios.interceptors.response.use(data => {
  return data;
}, error => {
  let status = error.response.status;
  let route = document.location.href.split("#")[1];
  if (status === 403) {
    sessionStorage.clear();
    vm.$router.push({
      path: "/login",
      query: {
        route: route,
        activeIndex: route.split("?")[0]
      }
    })
  } else {
    vm.$message.error(error.response.data.msg)
  }
  return Promise.reject(error);
})



// WEBPACK FOOTER //
// ./src/main.js